import { render, staticRenderFns } from "./title-index.vue?vue&type=template&id=3663b486"
import script from "./title-index.vue?vue&type=script&lang=js"
export * from "./title-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports